import {
    SET_FEVICYRL_CONTENT_SUCCESS,
    SET_FEVICYRL_CONTENT_FAIL,
    SET_WORKSHOP_LIST_SUCCESS,
    SET_WORKSHOP_LIST_FAIL,
    SET_WORKSHOP_CMDI_LIST_SUCCESS,
    SET_WORKSHOP_CMDI_LIST_FAIL,
    SET_PAYMENT_LIST_SUCCESS,
    SET_PAYMENT_LIST_FAIL,
    SET_WORKSHOP_AMMD_LIST_SUCCESS,
    SET_WORKSHOP_AMMD_LIST_FAIL,
    SET_PAYMENT_AMMD_LIST_SUCCESS,
    SET_PAYMENT_AMMD_LIST_FAIL,
    SET_MY_DATABASE_SUCCESS,
    SET_MY_DATABASE_FAIL,
} from '../constants/action-types';

const initialState = {
    data: [], // only storing FCCAllResult
};

const initialDatabaseState = {
    data: {},
};

export const fevicyrlContentReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_FEVICYRL_CONTENT_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_FEVICYRL_CONTENT_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const workshopListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_WORKSHOP_LIST_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_WORKSHOP_LIST_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const workshopCmdiListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_WORKSHOP_CMDI_LIST_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_WORKSHOP_CMDI_LIST_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const paymentListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_PAYMENT_LIST_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_PAYMENT_LIST_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const workshopAmmdListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_WORKSHOP_AMMD_LIST_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_WORKSHOP_AMMD_LIST_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const paymentAmmdListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_PAYMENT_AMMD_LIST_SUCCESS:
            return {
                ...state,
                data: payload,
            };
        case SET_PAYMENT_AMMD_LIST_FAIL:
            return {
                ...state,
                data: [],
            };
        default:
            return state;
    }
};

export const myDatabaseReducer = (state = initialDatabaseState, { type, payload }) => {
    switch (type) {
        case SET_MY_DATABASE_SUCCESS:
            return {
                ...state,
                data: {
                    FCPAll: payload.all,
                    FCPActive: payload.active,
                    FCPInactive: payload.inactive,
                },
            };
        case SET_MY_DATABASE_FAIL:
            return {
                ...state,
                data: {},
            };
        default:
            return state;
    }
};
